// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__19ske","header":"styles_header__3w4kJ","actions":"styles_actions__28kv2","firstButton":"styles_firstButton__2emO4"};